import Accordion from './Accordion';
import Panel from './Panel';

Accordion.Panel = Panel;

export default Accordion;